import API from "./axios";

export const settingsApi = {
  get:    ()     => API.get("/settings"),
  update: (data) => API.put("/settings", data),
};